import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Checkbox, FormLabel } from '@mui/material';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';
import { over, get, set } from '@totalsoft/change-tracking-react';
import { getErrors, isValid } from '@totalsoft/pure-validations-react';
import { useTranslation } from 'react-i18next';
import { emptyString } from 'utils/constants';




const AccountStatementIndicatorsModalEditComponent = ({ indicatorLens, validation, financialIndicatorList }) => {
    const indicator = indicatorLens |> get;
    const { t } = useTranslation();

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={1}>
                    <TextField
                        label={t('AccountStatement.Indicators.OrderNo')}
                        isNumeric
                        fullWidth
                        value={(indicatorLens.orderNo |> get) || emptyString}
                        variant='standard'
                        onChange={indicatorLens.orderNo |> set}
                        error={!isValid(validation.orderNo)}
                        helperText={getErrors(validation.orderNo)}
                        decimalScale={0}
                        disabled={true}
                    />
                </Grid>
                <Grid item xs={1}>
                    <TextField
                        label={t('AccountStatement.Indicators.ComputeOrder')}
                        isNumeric
                        fullWidth
                        value={(indicatorLens.computeOrder |> get) || emptyString}
                        variant='standard'
                        onChange={indicatorLens.computeOrder |> set}
                        error={!isValid(validation.computeOrder)}
                        helperText={getErrors(validation.computeOrder)}
                        decimalScale={0}
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField
                        label={t('AccountStatement.Indicators.Code')}
                        fullWidth
                        value={(indicatorLens.code |> get) || emptyString}
                        variant='standard'
                        onChange={indicatorLens.code |> set}
                        error={!isValid(validation.code)}
                        helperText={getErrors(validation.code)}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        label={t('AccountStatement.Indicators.AttributeName')}
                        fullWidth
                        value={(indicatorLens.attributeName |> get) || emptyString}
                        variant='standard'
                        onChange={indicatorLens.attributeName |> set}
                        error={!isValid(validation.attributeName)}
                        helperText={getErrors(validation.attributeName)}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        label={t('AccountStatement.Indicators.Name')}
                        fullWidth
                        value={(indicatorLens.name |> get) || emptyString}
                        variant='standard'
                        onChange={indicatorLens.name |> set}
                        error={!isValid(validation.name)}
                        helperText={getErrors(validation.name)}
                    />
                </Grid>

                <Grid item xs={6}>
                    <Autocomplete
                        label={t('AccountStatement.Indicators.FinancialIndicatorName')}
                        fullWidth
                        valueKey='id'
                        labelKey='name'
                        value={{ id: indicator.financialIndicatorId, name: indicator.financialIndicatorName }}
                        options={financialIndicatorList}
                        onChange={event => {
                            over(indicatorLens, oldState => ({
                                ...oldState,
                                financialIndicatorId: event.id,
                                financialIndicatorName: event.name
                            }));
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label={t('AccountStatement.Indicators.Expression')}
                        fullWidth
                        value={(indicatorLens.expression |> get) || emptyString}
                        variant='standard'
                        onChange={indicatorLens.expression |> set}
                        error={!isValid(validation.expression)}
                        helperText={getErrors(validation.expression)}
                        multiline
                        maxRows={4}
                    />
                </Grid>
                <Grid item xs={2}>
                    <Checkbox
                        checked={indicator.readOnlyYN || false}
                        onChange={() => set(indicatorLens.readOnlyYN)(!indicator.readOnlyYN)}
                    />
                    <FormLabel>{t('AccountStatement.Indicators.ReadOnly')}</FormLabel>
                </Grid>
                <Grid item xs={2}>
                    <Checkbox
                        checked={indicator.visibleYN || false}
                        onChange={() => set(indicatorLens.visibleYN)(!indicator.visibleYN)}
                    />
                    <FormLabel>{t('AccountStatement.Indicators.Visible')}</FormLabel>
                </Grid>
            </Grid>
        </>
    );
};

AccountStatementIndicatorsModalEditComponent.propTypes = {
    indicatorLens: PropTypes.object.isRequired,
    validation: PropTypes.object.isRequired,
    financialIndicatorList: PropTypes.array.isRequired
};

export default AccountStatementIndicatorsModalEditComponent;